document.addEventListener("DOMContentLoaded", () => {
  var ShowcaseSwiper = new Swiper(".showcase-details-carousel", {
    // cssMode: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    autoHeight: false,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    // mousewheel: true,
    // keyboard: true,
  });
  
  //   // 初始化elevateZoom-plus
  // // $img.ezPlus({
  // //   cursor: 'pointer',
  // //     constrainType: 'height',
  // //     constrainSize: 200,
  // //     zoomType: 'lens',
  // //     containLensZoom: true,
  // //     loadingIcon: 'http://www.elevateweb.co.uk/spinner.gif'
  // // });
  //   });
  
  $('.product-zoom-image').on('click',function(e){
    e.preventDefault();
    
    var $this = $(this);
    var largeSrc = $this.attr('data-zoom-image');

    //获取所有图片项，构建图集
    var items = [];
    $('.product-zoom-image').each(function(){
      items.push({
        src:$(this).attr('data-zoom-image'),
        type:'image'
      });
    });

    //获取当前点击是第几张（用于startIndex）
    var index = $('.product-zoom-image').index($this);
    //打开Fancybox图集
    $.fancybox.open(items,{
      index:index,
      animationEffect:"fade",
      transitionEffect:'fade',
      clickOutside: "close",
      btnTpl: {
        zoom:
              '<button data-fancybox-zoom class="fancybox-button fancybox-button--zoom" title="Zoom">' +
                '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
                  '<circle cx="11" cy="11" r="8"/>' +
                  '<line x1="21" y1="21" x2="16.65" y2="16.65"/>' +
                  '<line x1="11" y1="8" x2="11" y2="14"/>' +
                  '<line x1="8" y1="11" x2="14" y2="11"/>' +
                '</svg>' +
              '</button>'
              },
      buttons: ['zoom', 'close'], // 可选工具栏按钮
      wheel: true // 禁用滚轮关闭

    })


    });
})

